import { render, staticRenderFns } from "./ScheduleSettingCard.vue?vue&type=template&id=11950ca8&scoped=true&"
import script from "./ScheduleSettingCard.vue?vue&type=script&lang=ts&"
export * from "./ScheduleSettingCard.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleSettingCard.vue?vue&type=style&index=0&id=11950ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11950ca8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VDivider,VIcon})
